/**
 * MouseUtil.ts
 */
export class MouseUtil {
    static setInteractive(displayObject, interactive) {
        displayObject.eventMode = interactive ? "static" : "passive";
        displayObject.cursor = interactive ? "pointer" : null;
    }
    static addMouseDown(displayObject, handler, scope) {
        displayObject.on("pointerdown", handler, scope);
    }
    static addMouseUp(displayObject, handler = null, scope = null) {
        displayObject.on("pointerup", handler, scope);
        displayObject.on("pointerupoutside", handler, scope);
    }
    static addMouseOver(displayObject, handler, scope) {
        displayObject.on("pointerover", handler, scope);
    }
    static addMouseOut(displayObject, handler, scope) {
        displayObject.on("pointerout", handler, scope);
    }
    static addMouseMove(displayObject, handler, scope) {
        displayObject.on("pointermove", handler, scope);
    }
    static addMouseBlock(displayObject, clickHandler, scope) {
        displayObject.eventMode = "static";
        if (clickHandler) {
            this.addMouseUp(displayObject, clickHandler, scope);
        }
        else {
            displayObject.on("pointerup", this.handleMouseBlock, this);
            displayObject.on("pointerupoutside", this.handleMouseBlock, this);
        }
        displayObject.on("pointerdown", this.handleMouseBlock, this);
        displayObject.on("pointerover", this.handleMouseBlock, this);
        displayObject.on("pointerout", this.handleMouseBlock, this);
    }
    static addMouseClick(displayObject, handler, scope) {
        displayObject.on("pointertap", handler, scope);
    }
    static removeMouseDown(displayObject, handler) {
        displayObject.off("pointerdown", handler);
    }
    static removeMouseUp(displayObject, handler) {
        displayObject.off("pointerup", handler);
        displayObject.off("pointerupoutside", handler);
    }
    static removeMouseOver(displayObject, handler) {
        displayObject.off("pointerover", handler);
    }
    static removeMouseOut(displayObject, handler) {
        displayObject.off("pointerout", handler);
    }
    static removeMouseMove(displayObject, handler) {
        displayObject.off("pointermove", handler);
    }
    static removeMouseClick(displayObject, handler) {
        displayObject.off("pointertap", handler);
    }
    static handleMouseBlock(event) {
        if (event.originalEvent) {
            event.originalEvent.stopImmediatePropagation();
        }
    }
}
//# sourceMappingURL=MouseUtil.js.map